export { SegmentTag } from './SegmentTag'
export { SegmentHOC } from './SegmentHOC'